import styled from 'styled-components'

import { FileItemSize } from './file-item.types'

export const Container = styled.div<{
  $isLoading: boolean
  $isClickable: boolean
  $size: FileItemSize
}>(({ theme, $isLoading, $isClickable, $size }) => ({
  '&:focus-visible': {
    outline: $isClickable ? `${theme.border.size['2']} solid ${theme.colors.blue500}` : undefined,
  },
  '&:hover': {
    backgroundColor: $isClickable && !$isLoading ? theme.colors.gray100 : undefined,
  },
  alignItems: 'center',
  alignSelf: 'stretch',
  border: `${theme.border.size['1']} solid ${theme.colors.gray300}`,
  borderRadius: theme.border.radius['12'],
  cursor: $isLoading ? 'wait' : $isClickable ? 'pointer' : 'default',
  display: 'flex',
  gap: theme.space['8'],
  justifyContent: 'space-between',
  padding: '0.8rem',
  pointerEvents: $isLoading ? 'none' : 'auto',
  transition: `background-color ${theme.transition.duration.sm} ease`,
  ...($size === 'medium' ? { height: '5.6rem' } : {}),
}))

export const IconWrapper = styled.div<{ $size: FileItemSize }>(({ theme, $size }) => ({
  alignItems: 'center',
  aspectRatio: '1 / 1',
  backgroundColor: theme.colors.gray200,
  borderRadius: theme.border.radius['8'],
  display: 'flex',
  flexShrink: 0,
  justifyContent: 'center',
  overflow: 'hidden',
  ...($size === 'large'
    ? {
        height: '8rem',
        width: '8rem',
      }
    : {
        height: '4rem',
        width: '4rem',
      }),
}))

export const TextWrapper = styled.div(() => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minWidth: 0,
}))

export const PreviewImg = styled.img<{ $isVisible: boolean }>(({ $isVisible }) => ({
  display: $isVisible ? 'block' : 'none',
  height: '100%',
  objectFit: 'cover',
  width: '100%',
}))

export const CloseButtonWrap = styled.div(() => ({
  flexShrink: 0,
  marginLeft: 'auto',
}))
